import { favoritedCourses } from 'components/organisms/UpDashboard/constants';
import CourseList from '../../CourseList';

export default function Favorited() {
  return <CourseList courses={favoritedCourses} />;
}
